/* Suresh Peddavoora 12/22/2022 3075154998 Added Accordions for Preprocessor Table
Akhila 12/23/2022 3075154998 Added PopUp and field in PopUp in Add Condition button
Sohel 12/23/2022 3075154998 Preprocessor new Ux Changes
Sohel 12/28/2022 3075154998 Condition Table Changes
Sohel 12/30/2022 3075154998 integrated Save and get API
Akhila 12/30/2022 3075154998 Added Field Validation
Sohel 01/02/2022 3075154998 populate Processor Group
Sohel 01/02/2022 2698964415 pass condition deleted ids in payload
Sohel 01/04/2022 2698964415 pass props
Sai maheshwar 01/06/2023 2701334326 added processor group seq number
dilip 01/10/2023 2701334326 Added unsaved popup.
dilip 01/10/2023 2701334326 Fixed page break issue in preprocessor group.
kavyareddy 01/10/2023  2701334326 Fixed label issue
Sohel 01/11/2023 2701334326 Added Pre Processor Name Validation
Sohel 01/12/2023 2701334326 Added Pre Processor payload Changes
Sohel 01/11/2023 2701334326 Added Pre Processor Name Validation
Ashraf 01/12/2023 2701334326 Added tooltip to save button
Ashraf 01/13/2023 2701334326 fixed inappropriate text.
Sohel 01/13/2023 2701334326 hide value field based on Condition
Dilip 01/13/2023 2701334326 Added reset functionality
Sai maheshwar 01/13/2023 2698925801, 2699294669 fixed double save button issue
Sohel 01/17/2023 2701334326 removed validation
Sohel 01/17/2023 2698964415 payload Changes
Sohel 01/18/2023 2698964415 added unSaved Popup in go back button
Sohel 01/18/2023 2698964415 UnSaved Changes Fixed Popup issue
Sohel 01/19/2023 2698964415 added Action Tooltip
Sohel 01/22/2023 2698964415 pass Record Group Props
Sohel 01/23/2023 2698964415 payload changes
Sohel 01/23/2023 2698964415 validation API payload changes
Sohel 01/23/2023 3075154998 payload changes
Sohel 01/24/2023 2698964415 removed space between Temp repo
Ravi 01/02/2023 2698964415 fixed validation issue
Ashraf 02/02/2023 2698964415 fixed is blank expression
Sohel 02/07/2023 2698964415 fixed preprocessor validation issue
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed
Dilip 03/01/2023 2698964415 added preprocessor duplicate check validation
Ravi 03/08/2023 2698964415 rename Add Preprocessor to Add Data Transformation
Sohel 03/14/2023 2698964415 Added Error Reason in Payload
Sohel 03/17/2023 2698964415 Fixed Action Dropdown data issue
Dilip 03/21/2023 2701335619 Fixed label changes.
Sohel 03/24/2023 2701335619 rename Tooltip
Sohel 03/24/2023 2701335619 renamed labels
Dilip 03/28/2023 2701335619 Fixed delete id's in save api payload issue.
Akhila 03/29/2023 2701335619 unsaved changes popup fixed
Prakash 03/29/2023 2701335619 Added margin spacing.
Sohel 03/30/2023 2701335619 hide handleDirty
Sohel 04/08/2023 2698964415 Payload Changes
Akhila 04/10/2023 2698964415 unsaved changes bug fixed
Prakash 12-04-23 2698964415 fixed set cll back fields issue in account summaery.
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Prakash 19/04/2023 2698964415 add form group class for input filed.
Akhila 04/20/2023 2698964415 Added bew feature map data transformation
Akhila 04/25/2023 2698964415  Added usage and override functionality in transformation group
Akhila 04/24/2023 2698964415 bug fixed and prepoulated data
Akhila 04/25/2023 2698964415 rename the usage dialoge box
Sohel 05/15/2023 2698964415 Fixed Data Transformation disabled Issue
Ravi 05/16/2023 2698964415 Fixed page Break issue
Sohel 05/31/2023 2698964415 Fixed Accordian open issue
Akhila 06/12/2023 2698964415 added role access
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
Ravi 06/19/2023 2698964415 Added Breadcrum in popup
Ravi 06/19/2023 2698964415 show code and description conditionally on BreadCrum
Ravi 06/23/2023 2698964415 fixed submit issue
Sohel 10/10/2023 2700912712 Fixed Repository Name Space Issue
Sohel 12/12/2023 2700912712 label name change code to name
Sohel 16/12/2023 2700912712 Fixed Save API Payload Issue
*/
import React, {useEffect, useState, useContext, useRef} from 'react';
import {
  Button,
  TextField,
  FormHelperText,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import DMRaddRule from './DMRaddRule';
import DialogBox from '../../../../../components/DialogBox';
import {Field, FieldArray, Form, Formik} from 'formik';
import PreProcessor from './PreProcessor';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchPreProcessorGroupNames,
  postPreProcessorGroup,
  resetPreProcessorGroup,
  fetchPreProcessorNames,
  resetErrorWarningMsg,
  isResetloadingbar,
  resetPreprocessorUsageData,
  fetchFieldsData,
} from '../../../../../redux/reducers/DataManagerRecord';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import DMRFieldSelect from './DMRFieldSelect';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import SearchMapDataTransform from './SearchMapDataTransform';
import WarningErrorPopup from './SearchMapDataTransform/WarningErrorPopup';
import OverrideRule from '../../../../../components/OverrideRule';
import BreadCrums from '../../../../../util/BreadCrum';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '12px',
    },
    '& .MuiAccordion-root': {
      borderRadius: '0px !important',
    },
  },
  accordionDetailsStyling: {
    border: '1px solid #0000003b !important',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
    // boxShadow:
    //   "0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)",
  },
}));

function DMRProcessorGroup({
  setShowSearch,
  setProcessorGroupCode,
  exportManagerRecord,
  handleDirty,
  showAlert,
  showAlertRef,
  managerRecordGroup = false,
  editExisting,
  dmTempRecordAccess,
  exportRecordGroupAccess,
  importRecordGroupAccess,
}) {
  const [dialogState, setDialogState] = useState(false);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const [codePopover, setCodePopover] = useState(false);
  const submitRef = useRef(true);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const actionDeleteIdsRef = useRef({});
  const conditionDeletedIds = useRef({});
  const processorDeleteRef = useRef([]);
  const [dataTransformOpen, setDataTransformOpen] = useState(false);
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [overRiding, setOverRiding] = useState({});
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    isPreprocessorLoading,
    preProcessorSuccessMsg,
    preProcessorErrorMsg,
    preProcessorStatus,
    recordCode,
    processorStatus,
    prepProcessorGroupData,
    preprocessorGroupNames,
    processorSuccessMsg,
    warningError,
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    dataTranformationData,
    basicInfoErrorMsg,
    addUsageData,
    userMetrix,
    addProcessorSuccessMsg,
    basicInfoData: basicInfodata,
    dataManagerRecordId,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {
    groupCode: recordGroupCode,
    basicInfoData,
    dmRecordGroupId,
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const [groupCode, setGroupCode] = useState('');
  const initialVal = {
    groupName: '',
    groupDescription: '',
    preprocessors: [],
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const [tempDataTranform, setTempDataTransform] = useState([]);
  const [warningOpen, setWarningOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleDataTansformDialog = () => {
    setDataTransformOpen(close);
    dispatch(resetErrorWarningMsg());
  };
  const checkRecordCodeExist = (value) => {
    if (preprocessorGroupNames && preprocessorGroupNames?.length > 0 && value) {
      const ar = [];
      preprocessorGroupNames.filter((i) => {
        if (i?.processorGroupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const disabledSave = (data) => {
    const arr = data?.filter((i) => i?.actions?.length === 0);
    if (arr?.length === 0) {
      return false;
    } else {
      return true;
    }
  };
  const validationSchema = Yup.object().shape({
    groupName: prepProcessorGroupData?.processorGroupCode ?
      null :
      Yup.string()
        .test('code', 'Transformation Group Name is required', (value) => {
          return value?.replaceAll(' ', '');
        })
        .required('Transformation Group Name is required')
        .test(
          'code',
              `Transformation Name already used in another Transformation Group`,
              (value) => !checkRecordCodeExist(value),
        ),
    groupDescription: Yup.string()
      .test('description', 'Transformation Group Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Transformation Group Description is required'),
    preprocessors: Yup.array().of(
      Yup.object().shape({
        preprocessorName: Yup.string()
          .test('description', 'Data Transformation is required', (value) => {
            return value?.replaceAll(' ', '');
          })
          .required('Data Transformation is required')
          // .test(
          //   "description",
          //   `Data Transformation is used in other Transformation Group`,
          //   (value) => !checkPreprocessorCodeExist(value)
          // )
          .test(
            'duplicate check',
            (path) => {
              return `${path.value} is already defined`;
            },
            (value, context) => {
              const form = context.from[1] || [];
              const tempFieldNames = form?.value?.preprocessors.filter(
                (el) => el.preprocessorName === value,
              );
              if (value && tempFieldNames.length > 1) {
                return false;
              } else {
                return true;
              }
            },
          ),
      }),
    ),
  });

  const handleDialogState = () => {
    setDialogState(false);
  };
  const handleDragEnd = (result, {setFieldValue, values}) => {
    const {destination, source} = result;

    if (!destination) {
      return;
    }
    const copyArr = [...values.preprocessors];
    const arr1 = copyArr.splice(source.index, 1);
    copyArr.splice(destination.index, 0, arr1[0]);
    setFieldValue('preprocessors', copyArr);
  };
  useEffect(() => {
    if (addProcessorSuccessMsg === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetPreprocessorUsageData());
      }, 2500);
    }
  }, [userMetrix, addProcessorSuccessMsg]);
  useEffect(() => {
    const moduleType = managerRecordGroup ? 'Record Group' : 'Record';
    dispatch(fetchPreProcessorGroupNames(moduleType, type));
    dispatch(fetchPreProcessorNames(type));
  }, []);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetErrorWarningMsg());
      }, 1500);
    }
  }, [basicInfoSuccessMsg, basicInfoErrorMsg]);
  useEffect(() => {
    if (preProcessorSuccessMsg || preProcessorErrorMsg) {
      setTimeout(() => {
        dispatch(resetPreProcessorGroup());
      }, 1500);
    }
  }, [preProcessorErrorMsg, preProcessorSuccessMsg]);
  useEffect(() => {
    if (processorStatus === 200 && processorSuccessMsg) {
      if (dataManagerRecordId && !managerRecordGroup) {
        dispatch(fetchFieldsData(type, dataManagerRecordId, managerRecordGroup));
      } else if (dmRecordGroupId && managerRecordGroup) {
        dispatch(fetchFieldsData(type, dmRecordGroupId, managerRecordGroup));
      }
    }
  }, [processorStatus, processorSuccessMsg]);
  useEffect(() => {
    if (preProcessorStatus === 200 && preProcessorSuccessMsg) {
      setTimeout(() => {
        setProcessorGroupCode(
          prepProcessorGroupData?.processorGroupCode ?
            prepProcessorGroupData?.processorGroupCode :
            groupCode,
        );
        dispatch(resetPreProcessorGroup());
        setShowSearch(false);
      }, 1500);
    }
  }, [preProcessorStatus, preProcessorSuccessMsg]);
  window.onclick = function() {
    setCodePopover(false);
  };
  const handleExpression = (arr, condition) => {
    const result = arr.map((el, i) => el.conditionCode);
    return result.join(` ${condition} `);
  };
  const getRecordCodesData = () => {
    if (preprocessorGroupNames && preprocessorGroupNames?.length > 0) {
      return preprocessorGroupNames?.filter((i) =>
        String(i.processorGroupCode)?.startsWith(groupCode),
      );
    } else {
      return [];
    }
  };
  useEffect(() => {
    if (warningError !== null) {
      setWarningOpen(true);
      setTimeout(() => {
        dispatch(isResetloadingbar());
      }, 1000);
    }
  }, [warningError, isResetloadingbar]);
  const handleValidationClose = () => {
    setWarningOpen(false);
    // setValidationError(false);
    // setStatus(true);
    dispatch(resetErrorWarningMsg());
    // setProcessorGroupCode("");
  };
  useEffect(() => {
    if (prepProcessorGroupData) {
      const processorData = prepProcessorGroupData?.dmProcessorRequestList ?
        prepProcessorGroupData?.dmProcessorRequestList?.map((el) => {
          return {
            ...el,
            isDataTransformation: el?.isDataTransformation === 'Y' ? true : false,
            preprocessorName: el?.processorCode ? el?.processorCode : '',
            dmProcessorId: el?.dmProcessorId ? el?.dmProcessorId : '',
            resultExpCondition: el?.defaultOperator ? el?.defaultOperator : '',
            result: el?.defaultOperator ?
              handleExpression(el.dmProcessorConditionRequest, el.defaultOperator) :
              el?.resultExpr ?
                el?.resultExpr :
                '',
            actions:
                el?.dmProcessorActionRequest?.length > 0 ?
                  el?.dmProcessorActionRequest?.map((i) => {
                    return {
                      ...i,
                      parameter:
                          i?.actionName === 'Change Status' && i?.rhsRuleExpression ?
                            JSON.parse(i?.rhsRuleExpression) :
                            i?.rhsRuleExpression || '',
                      action: i?.actionName ? i?.actionName : '',
                      dataManagerProcessorActionId: i?.dataManagerProcessorActionId ?
                        i?.dataManagerProcessorActionId :
                        0,
                      field: {
                        fieldName: i?.fieldName ? i?.fieldName : '',
                        dataType: i?.fieldType ? i?.fieldType : '',
                        repositoryName: i?.repositoryName ? i?.repositoryName : '',
                      },
                      selectField:
                          i?.actionName === 'Error Record' && exportManagerRecord ?
                            i?.fieldFromName :
                            {
                              fieldName: i?.fieldFromName ? i?.fieldFromName : '',
                              dataType: i?.fieldFromType ? i?.fieldFromType : '',
                              repositoryName: i?.repositoryFromName ? i?.repositoryFromName : '',
                            },
                      formulaExpression: i?.rhsFormulaExpression ? i?.rhsFormulaExpression : '',
                    };
                  }) :
                  [],
            conditions:
                el?.dmProcessorConditionRequest?.length > 0 ?
                  el?.dmProcessorConditionRequest?.map((i) => {
                    return {
                      ...i,
                      expression: i?.rhsRuleExpression ? i?.rhsRuleExpression : '',
                      ruleCode: i?.conditionCode ? i?.conditionCode : '',
                      dmProcessorCondId: i?.dmProcessorCondId ? i?.dmProcessorCondId : 0,
                      field: {
                        fieldName: i?.fieldName,
                        repositoryName: i?.repositoryName,
                        dataType: i?.field1Type,
                      },
                      selectField: {
                        fieldName: i?.field2Name,
                        dataType: i?.field2Type,
                        repositoryName: i?.field2RepositoryName,
                      },
                      // operators : i?.condOperator ? getObjects(i?.condOperator,conditionDropdown) :"",
                      condition: i?.compareValue ? i?.compareValue : '',
                    };
                  }) :
                  [],
          };
        }) :
        [];

      const newData = {
        groupName: prepProcessorGroupData?.processorGroupCode ?
          prepProcessorGroupData?.processorGroupCode :
          '',
        groupDescription: prepProcessorGroupData?.processorType ?
          prepProcessorGroupData?.processorType :
          '',
        preprocessors: processorData,
      };
      setInitialValues(newData);
    }
  }, [prepProcessorGroupData]);
  const handleSubmit = (values) => {
    if (submitRef.current) {
      dispatch(submissionStart());
      const preProcessors =
        values?.preprocessors?.length > 0 ?
          values?.preprocessors?.map((el, i) => {
            return {
              deletedDataManagerProcessorActionId:
                  actionDeleteIdsRef.current?.[el?.preprocessorName]?.filter(Boolean).length > 0 ?
                    actionDeleteIdsRef.current?.[el?.preprocessorName]?.filter(Boolean) :
                    [0],
              seqNum: i + 1,
              deletedDmProcessorCondId:
                  conditionDeletedIds.current?.[el?.preprocessorName]?.filter(Boolean)?.length > 0 ?
                    conditionDeletedIds.current?.[el?.preprocessorName]?.filter(Boolean) :
                    [0],
              dmProcessorActionRequest:
                  el?.actions?.length > 0 ?
                    el?.actions?.map((i) => {
                      return {
                        actionCode: '',
                        actionName: i?.action ? i?.action : i?.actionName ? i?.actionName : '',
                        compareValue: '',
                        dataManagerProcessorActionId: i?.dataManagerProcessorActionId ?
                          i?.dataManagerProcessorActionId :
                          0,
                        fieldFromName:
                            i?.action === 'Error Record' && exportManagerRecord ?
                              i?.selectField :
                              i?.selectField?.fieldName ?
                                i?.selectField?.fieldName :
                                i?.fieldFromName ?
                                  i?.fieldFromName :
                                  '',
                        fieldFromType: i?.selectField?.dataType ?
                          i?.selectField?.dataType :
                          i?.fieldFromType ?
                            i?.fieldFromType :
                            '',
                        fieldName: i?.fields?.fieldName ? i?.fields?.fieldName : '',
                        fieldType: i?.fields?.dataType ? i?.fields?.dataType : '',
                        processorCode: el?.preprocessorName ?
                          el?.preprocessorName :
                          el?.processorCode ?
                            el?.processorCode :
                            '',
                        repositoryFromName: i?.selectField?.repositoryName ?
                          i?.selectField?.repositoryName :
                          i?.repositoryFromName ?
                            i?.repositoryFromName :
                            '',
                        repositoryName: i?.fields?.repositoryName ?
                          i?.fields?.repositoryName :
                          '',
                        rhsRuleExpression:
                            i?.action === 'Change Status' && i?.parameter ?
                              JSON.stringify(i?.parameter) :
                              i?.parameter || '',
                        rhsFormulaExpression: i?.formulaExpression ?
                          i?.formulaExpression :
                          i?.rhsFormulaExpression ?
                            i?.rhsFormulaExpression :
                            '',
                        errorReason: i?.errorReason ? i?.errorReason : '',
                      };
                    }) :
                    [],
              dmProcessorConditionRequest:
                  el?.conditions?.length > 0 ?
                    el?.conditions?.map((i) => {
                      return {
                        compareValue: i?.condition ? i?.condition : '',
                        condOperator: i?.operators?.valueCode ? i?.operators?.valueCode : '',
                        conditionCode: i?.ruleCode ? i?.ruleCode : '',
                        dmProcessorCondId: i?.dmProcessorCondId ? i?.dmProcessorCondId : 0,
                        field1Type: i?.fields?.dataType ? i?.fields?.dataType : '',
                        field2Name: i?.selectField?.fieldName ? i?.selectField?.fieldName : '',
                        field2RepositoryName: i?.selectField?.repositoryName ?
                          i?.selectField?.repositoryName :
                          '',
                        field2Type: i?.selectField?.dataType ? i?.selectField?.dataType : '',
                        fieldName: i?.fields?.fieldName ? i?.fields?.fieldName : '',
                        processorCode: el?.preprocessorName ? el?.preprocessorName : '',
                        repositoryName: i?.fields?.repositoryName ?
                          i?.fields?.repositoryName :
                          '',
                        rhsFormulaExpression: i?.rhsFormulaExpression ?
                          i?.rhsFormulaExpression :
                          '',
                        rhsRuleExpression: i?.expression ? i?.expression : '',
                      };
                    }) :
                    [],
              dmProcessorId: el?.dmProcessorId ? el?.dmProcessorId : 0,
              processorCode: el?.preprocessorName ? el?.preprocessorName : '',
              processorGroupCode: values?.groupName ? values?.groupName : '',
              resultExpr: el?.result ? el?.result : '',
              defaultOperator: el?.resultExpCondition ? el?.resultExpCondition : '',
              isDataTransformation: el?.isDataTransformation ? 'Y' : 'N',
            };
          }) :
          [];
      const payload = {
        deletedDMProcessorIds:
          processorDeleteRef.current?.filter(Boolean)?.length > 0 ? processorDeleteRef.current : [],
        dmProcessorGroupId: prepProcessorGroupData?.dmProcessorGroupId ?
          prepProcessorGroupData?.dmProcessorGroupId :
          0,
        dmProcessorRequestList: preProcessors,
        isDraft: 'N',
        processorGroupCode: values?.groupName ? values?.groupName : '',
        processorType: values?.groupDescription ? values?.groupDescription : '',
        type: exportManagerRecord ? 'Export' : 'Import',
        recordCode: managerRecordGroup ? recordGroupCode : recordCode,
        moduleType: managerRecordGroup ? 'Record Group' : 'Record',
        override: 'No',
        dmRecordId:managerRecordGroup && dmRecordGroupId ? dmRecordGroupId : !managerRecordGroup && dataManagerRecordId ? dataManagerRecordId : 0,
      };
      setOverRiding(payload);
      dispatch(postPreProcessorGroup(payload));
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values) => handleSubmit(values)}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleChange,
            resetForm,
            handleBlur,
            touched,
            errors,
            dirty,
          } = props;
          // handleDirty(dirty);
          if (dirty && showAlertRef) {
            // handleDirty(true);
            showAlertRef.current = dirty;
          }

          return (
            <>
              <Form noValidate>
                <div className="form-row global-field-textfields mt-3 new-standard-textfields ">
                  <div className={`col-sm-6 col-md-4  col-xl-3 form-group`}>
                    <TextField
                      className={` ${classes.labelName} w-100`}
                      placeholder="Enter Transformation Group Name"
                      margin="dense"
                      name="groupName"
                      variant="outlined"
                      value={values.groupName}
                      disabled={Boolean(prepProcessorGroupData?.processorGroupCode)}
                      onChange={(e) => {
                        setFieldValue('groupName', e.target.value);
                        setGroupCode(e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      onBlur={handleBlur}
                      label="Transformation Group Name"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={Boolean(touched.groupName && errors.groupName)}
                    />
                    <FormHelperText error>{touched.groupName && errors.groupName}</FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getRecordCodesData()?.map((data, i) => (
                          <MenuItem fullWidth key={i}>
                            {data?.processorGroupCode}
                          </MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className={`col-md-5 col-lg-4 col-xl-4 form-group`}>
                    <TextField
                      className={` ${classes.labelName} w-100`}
                      placeholder="Enter Transformation Group Description"
                      margin="dense"
                      name="groupDescription"
                      variant="outlined"
                      value={values.groupDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      label="Transformation Group Description"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={Boolean(touched.groupDescription && errors.groupDescription)}
                    />
                    <FormHelperText error>
                      {touched.groupDescription && errors.groupDescription}
                    </FormHelperText>
                  </div>
                </div>
                <Accordion className="accordion-styling mb-3" elevation={0}>
                  <AccordionSummary
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className={classes1.accordionDetailsStyling}
                    IconButtonProps={{edge: 'start'}}
                  >
                    <div className="d-flex align-items-center">
                      <ExpandMoreIcon />
                      <span
                      // style={{
                      //   backgroundColor: "#61ff8c",
                      //   padding: "7px 16px",
                      //   borderRadius: "25px",
                      //   fontWeight: "bold",
                      // }}
                      >
                        <Typography className={classes1.heading}>
                          <span className="mr-3">Selected Fields:</span>
                        </Typography>
                      </span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className="flex-column">
                    {/* <DMRRecordFormatFields handleDirty={handleDirty} exportManagerRecord={exportManagerRecord} processor={true} /> */}
                    <DMRFieldSelect
                      handleDirty={handleDirty}
                      exportManagerRecord={exportManagerRecord}
                      processor={true}
                      // showAlert={showAlert}
                      showAlertRef={showAlertRef}
                      managerRecordGroup={managerRecordGroup}
                    />
                  </AccordionDetails>
                </Accordion>
                <FieldArray
                  name="preprocessors"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        <div className="d-flex new-standard-textfields justify-content-end">
                          <Button
                            variant="outlined"
                            className={`search-btn mr-2`}
                            onClick={() => setDataTransformOpen(true)}
                            // disabled={!values?.category}
                            // disabled={values?.code === "" || values?.description === ""}
                            startIcon={<AccountTreeIcon />}
                          >
                            Map Data Transformation
                          </Button>
                          <Button
                            variant="outlined"
                            type="button"
                            className={`search-btn`}
                            startIcon={<AddIcon />}
                            onClick={() => {
                              submitRef.current = false;
                              arrayHelpers.push({
                                preprocessorName: '',
                                conditions: [],
                                actions: [],
                                resultExpCondition: 'AND',
                                result: '',
                              });
                              setExpanded(`panel1${values.preprocessors.length}`);
                              // submitForm()
                            }}
                          >
                            Data Transformation
                          </Button>
                        </div>
                        <DragDropContext
                          onDragEnd={(result) => {
                            handleDragEnd(result, {setFieldValue, values});
                          }}
                        >
                          <Droppable droppableId="preprocessors">
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                  backgroundColor: snapshot.isDraggingOver ? '#def2ff' : 'white',
                                  padding: '5px 8px',
                                  margin: '8px 0px',
                                }}
                              >
                                {values.preprocessors.map((el, index) => {
                                  return (
                                    <Field
                                      name={`preprocessors[${index}]`}
                                      component={PreProcessor}
                                      key={index}
                                      index={index}
                                      handleAccordionChange={handleAccordionChange}
                                      expanded={expanded}
                                      conditionDeletedIds={conditionDeletedIds}
                                      exportManagerRecord={exportManagerRecord}
                                      actionDeleteIdsRef={actionDeleteIdsRef}
                                      arrayHelpers={arrayHelpers}
                                      processorDeleteRef={processorDeleteRef}
                                      managerRecordGroup={managerRecordGroup}
                                      dataTranformationData={dataTranformationData}
                                    />
                                  );
                                })}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                    );
                  }}
                />
                <div className="d-flex justify-content-center align-items-center new-standard-textfields ">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      resetForm(initialValues);
                    }}
                  >
                    Reset
                  </Button>
                  <Tooltip
                    title={
                      values?.preprocessors?.length === 0 ?
                        'Add atleast one Data Transformation' :
                        disabledSave(values?.preprocessors) ?
                          'Please atleast one action in Data Transformation' :
                          ''
                    }
                  >
                    <div>
                      <Button
                        variant="outlined"
                        type="submit"
                        disabled={
                          values?.preprocessors?.length === 0 ||
                          disabledSave(values?.preprocessors) ||
                          (editExisting === 'Import' && !dmTempRecordAccess?.edit) ||
                          (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                          (editExisting === 'Export Record Group' &&
                            !exportRecordGroupAccess?.edit) ||
                          (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) || enabledSubmission
                        }
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          submitRef.current = true;
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </Tooltip>
                </div>
                {/* <div className="d-flex justify-content-end">
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn`}
                    startIcon={<AddIcon />}
                  >
                    Add Preprocessor
                  </Button>
                </div> */}
                {/* <div>
                  {values.preprocessors.map((el) => {
                    return <PreProcessor />;
                  })}
                </div> */}

                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title="Add Condtion"
                >
                  <DMRaddRule setOpen={setOpen} handleClose={handleClose} />
                </DialogBox>
                <DialogBox
                  open={dataTransformOpen}
                  dialogClose={handleDataTansformDialog}
                  // title="Search Data Transformation"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Data Transformation</b>
                      </p>
                      <BreadCrums
                        name={
                          managerRecordGroup && exportManagerRecord ?
                            'Export Record Group Name' :
                            managerRecordGroup && !exportManagerRecord ?
                              'Import Record Group Name' :
                              !managerRecordGroup && exportManagerRecord ?
                                'Export Template Record Name' :
                                'Import Template Record Name'
                        }
                        code={
                          managerRecordGroup ?
                            basicInfoData?.groupCode :
                            basicInfodata?.recordCode
                        }
                        description={
                          !managerRecordGroup && exportManagerRecord ?
                            'Export Template Record Description' :
                            managerRecordGroup ?
                                    `${type} Record Group Description` :
                              'Import Template Record Description'
                        }
                        descriptionValue={
                          managerRecordGroup ?
                            basicInfoData?.groupDescription :
                            basicInfodata?.recordDescription
                        }
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchMapDataTransform
                    mapDataTransform={true}
                    exportManagerRecord={exportManagerRecord}
                    setTempDataTransform={setTempDataTransform}
                    tempDataTranform={tempDataTranform}
                    setDataTransformOpen={setDataTransformOpen}
                    managerRecordGroup={managerRecordGroup}
                    setFieldValue={setFieldValue}
                    values={values}
                    handleDataTansformDialog={handleDataTansformDialog}
                  />
                </DialogBox>
                <DialogBox
                  open={warningOpen}
                  dialogClose={handleValidationClose}
                  title="Warning !"
                  maxWidth="sm"
                >
                  <WarningErrorPopup
                    handleValidationClose={handleValidationClose}
                    warningError={warningError}
                  />
                </DialogBox>
                <OverrideRule
                  dialogTitle="Override Rule"
                  dialogOpen={dialogState}
                  dialogClose={handleDialogState}
                  title={`This Data Transformation has been used in the following places.`}
                  handleOverrideClose={handleDialogState}
                  handleOverrideSubmit={() => {
                    dispatch(postPreProcessorGroup({...overRiding, override: 'Yes'}));
                    handleDialogState();
                  }}
                  data={addUsageData}
                  isDataTranformDelete={true}
                />
              </Form>
            </>
          );
        }}
      </Formik>
      {(isPreprocessorLoading || isBasicInfoLoading) && <PageLoader />}
      {(preProcessorErrorMsg || basicInfoErrorMsg) && (
        <ErrorSnackbar errorMsg={preProcessorErrorMsg || basicInfoErrorMsg} />
      )}
      {(preProcessorSuccessMsg || basicInfoSuccessMsg) && (
        <SuccessSnackbar successMsg={preProcessorSuccessMsg || basicInfoSuccessMsg} />
      )}
    </>
  );
}
export default DMRProcessorGroup;
